<template>
  <div style="display: flex; flex-direction: column" v-if="pureDate !== '0001-01-01T00:00:00' && pureDate">
    <center>{{ date }}</center>
    <center>{{ time }}</center>
  </div>
  <div style="display: flex; flex-direction: column" v-if="pureDate === '0001-01-01T00:00:00' || !pureDate">
    <center>{{$t("N/A")}}</center>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "tableDateFormatter",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  computed: {
    date() {
      // eslint-disable-next-line no-debugger
      // debugger;
      if (this.data) return moment(this.data[this.options.field]).format("L");
      else return "";
      // return this.data[this.options.field].split('T')[0]
    },
    time() {
      if (this.data)
        return moment(this.data[this.options.field]).format("hh:mm:ss A");
      else return "";
      // let time = this.data[this.options.field].split('T')[1].split(':')
      // return `${time[0]}:${time[1]}`
    },
    pureDate() {
      return this.data ? this.data[this.options.field] : null;
    },
  },
};
</script>

<style></style>
